'use strict';

var React = require('react');

function _interopDefaultCompat (e) { return e && typeof e === 'object' && 'default' in e ? e : { default: e }; }

var React__default = /*#__PURE__*/_interopDefaultCompat(React);

function SvgRefreshCircle(props) {
    return (React__default.default.createElement("svg", { width: "1em", height: "1em", viewBox: "0 0 16 16", xmlns: "http://www.w3.org/2000/svg", xmlnsXlink: "http://www.w3.org/1999/xlink", ...props },
        React__default.default.createElement("defs", null,
            React__default.default.createElement("path", { d: "M6 0c3.312 0 6 2.688 6 6s-2.688 6-6 6-6-2.688-6-6 2.688-6 6-6zm0 1.286A4.72 4.72 0 001.286 6 4.72 4.72 0 006 10.714 4.72 4.72 0 0010.714 6 4.72 4.72 0 006 1.286zm-.336 1.517a3.195 3.195 0 012.448.78l.095-.096a.59.59 0 011.007.418V5.25a.59.59 0 01-.59.589H7.278a.59.59 0 01-.414-1.007l.408-.408a1.995 1.995 0 00-1.274-.46A2.037 2.037 0 004.01 6.451c.159.75.767 1.364 1.518 1.53a2.037 2.037 0 002.313-1.125.59.59 0 011.054.527 3.21 3.21 0 01-2.9 1.831 3.21 3.21 0 01-3.189-3.59 3.228 3.228 0 012.857-2.821z", id: "Refresh-circle__svg__a" })),
        React__default.default.createElement("g", { fill: "none", fillRule: "evenodd" },
            React__default.default.createElement("path", { d: "M0 0h16v16H0z" }),
            React__default.default.createElement("g", { transform: "translate(2 2)" },
                React__default.default.createElement("path", { d: "M0 0h12v12H0z" }),
                React__default.default.createElement("use", { fill: "currentColor", xlinkHref: "#Refresh-circle__svg__a" })))));
}

module.exports = SvgRefreshCircle;
//# sourceMappingURL=RefreshCircle.js.map
